// Stats Card Component

/**
 * Render a stats card with icon, label, and value
 * @param {Object} props - Card properties
 * @param {string} props.icon - SVG icon markup
 * @param {string} props.label - Card label
 * @param {number|string} props.value - Card value
 * @param {string} [props.className] - Additional CSS class
 * @returns {string} HTML markup
 */
export function renderStatsCard({ icon, label, value, className = '' }) {
  return `
    <div class="stats-card ${className}">
      <div class="stats-card-icon">
        ${icon}
      </div>
      <div class="stats-card-content">
        <span class="stats-card-value">${formatNumber(value)}</span>
        <span class="stats-card-label">${escapeHtml(label)}</span>
      </div>
    </div>
  `;
}

/**
 * Format number with thousand separators
 * @param {number|string} value - Number to format
 * @returns {string} Formatted number
 */
function formatNumber(value) {
  if (value === null || value === undefined) return '-';
  const num = typeof value === 'string' ? parseInt(value, 10) : value;
  if (isNaN(num)) return '-';
  return num.toLocaleString('de-DE');
}

/**
 * Escape HTML special characters
 * @param {string} text - Text to escape
 * @returns {string} Escaped text
 */
function escapeHtml(text) {
  if (!text) return '';
  const div = document.createElement('div');
  div.textContent = text;
  return div.innerHTML;
}

// Stats card icons
export const STATS_ICONS = {
  users: `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
    <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
    <circle cx="9" cy="7" r="4"></circle>
    <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
    <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
  </svg>`,
  bookmarks: `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
    <path d="M19 21l-7-5-7 5V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2z"></path>
  </svg>`,
  newUsers: `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
    <path d="M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
    <circle cx="8.5" cy="7" r="4"></circle>
    <line x1="20" y1="8" x2="20" y2="14"></line>
    <line x1="23" y1="11" x2="17" y2="11"></line>
  </svg>`,
  activeUsers: `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
    <polyline points="22 12 18 12 15 21 9 3 6 12 2 12"></polyline>
  </svg>`
};
